import { render, staticRenderFns } from "./PaiementFacture.vue?vue&type=template&id=21380ec1&scoped=true"
import script from "./PaiementFacture.vue?vue&type=script&lang=js"
export * from "./PaiementFacture.vue?vue&type=script&lang=js"
import style0 from "./PaiementFacture.vue?vue&type=style&index=0&id=21380ec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21380ec1",
  null
  
)

export default component.exports